import App from './App'
import NotFoundPage from './NotFoundPage'

export default [
  {
    path: '/',
    component: App
  },
  {
    path: '*',
    component: NotFoundPage
  }
]
